import React from "react";
import BaseComponent from '../BaseComponent';
import PersonV2 from './PersonV2';

import Meet from 'images/team_meet.jpg';
import Raj from 'images/team_raj.jpg';

class LeadershipTeam extends BaseComponent {
  render() {
    return (
      <div className="pt-5 pb-5">
        <div className="container mt-5 mb-5">
          <div className="display-3 bold text-center dark-green mt-5 mb-5" data-aos="fade-up">
            Leadership Team
          </div>
          <div className="ps-wrap mt-4">
            <div className="row ps-filter person-alignment justify-content-center">
              <PersonV2 headshot={Raj} name="Rajatesh Gudibande" designation="CEO" linkedin="https://www.linkedin.com/in/rajatesh-gudibande-07108423" />
              <PersonV2 headshot={Meet} name="Meet Vora" designation="COO" linkedin="https://www.linkedin.com/in/meetvora" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LeadershipTeam
